import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { GoalInfo } from 'bp/modules/goal/models/goal-info.model';
import dayjs from 'dayjs';
import { GoalModel } from 'projects/bp-core/src/lib/proto/common-message.pb';
import { RedirectService } from 'projects/bp-core/src/lib/services/portal/redirect.service';
import { DecimalPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { BpCoreModule } from '../../../../../../bp-core/src/lib/bp-core.module';

@Component({
    selector: 'goal-progress-card',
    templateUrl: './goal-progress-card.component.html',
    styleUrls: ['./goal-progress-card.component.scss'],
    animations: fuseAnimations,
    standalone: true,
    imports: [
        BpCoreModule,
        MatIconModule,
        MatTooltipModule,
        MatProgressBarModule,
        DecimalPipe,
        CurrencyPipe,
        DatePipe,
    ],
})
export class GoalProgressCardComponent implements OnInit, OnChanges {
  @Input()
  goal: GoalModel;

  @Input()
  goalInfo: GoalInfo;

  isLoading = true;
  isCompatibleGoal = false;

  currentlyGoalMonths = 0;
  currentlyGoalMonthsFromFirstInvest = 0;
  monthOrMonths = 'meses';

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private redirectService: RedirectService,
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    this.isLoading = true;
    if (this.goal) {
      //determinar meses desde creacion de la meta
      const goalCreationDate = dayjs(this.goal.created?.toDate());
      const currentlyDate = dayjs();
      this.currentlyGoalMonths = currentlyDate.diff(goalCreationDate, 'month');

      const goalFirstInvestmentDate = dayjs(this.goal.firstTransactionDate?.toDate());
      this.currentlyGoalMonthsFromFirstInvest = currentlyDate.diff(
        goalFirstInvestmentDate,
        'month',
      );
      //determinas meses desde primera inversion

      //determinar si es mes o meses
      this.monthOrMonths = 'meses';
      if (this.currentlyGoalMonths == 1) {
        this.monthOrMonths = 'mes';
      }

      this.isLoading = false;
    }
  }

  ngOnInit() {}

  get getGoalTooltipMessage() {
    if (this.goal?.state == 'portfolioChange') {
      return 'Podrás acceder a esta pestaña una vez que el cambio de portafolio se haya realizado.';
    }
    if (!this.goal?.haveDeposited || !this.goal?.haveTransactionsProcessed) {
      return 'Podrás acceder a esta pestaña una vez que tu primer depósito haya sido invertido.';
    }

    return '';
  }
  goToSettings() {
    this.router.navigate(['/goals', this.goal?.id], {
      fragment: 'settings',
    });
    this.scrollToTop();
  }
  onShowModalSimulator() {
    // NUEVO DISEÑO MATERIAL
    /*const modalRef = this.dialog.open(SimulatorModalMatComponent, {
      data: {
        goal: this.goal,
      },
    });
    // FIN NUEVO DISEÑO MATERIAL

    modalRef.componentInstance.goal = this.goal;*/
  }
  goToEditPortfolio() {
    this.router.navigate(['/change-portfolio', this.goal.id], {
      fragment: 'edit',
    });
  }

  goPortfolio() {
    if (this.goal?.state == 'portfolioChange') {
      return;
    }
    if (this.goal?.haveDeposited && this.goal?.haveTransactionsProcessed) {
      this.router.navigate(['/goals', this.goal?.id], {
        fragment: 'portfolio',
      });
      this.scrollToTop();
    }
  }

  goPortfolioFromLateralCard() {
    if (this.goal?.state == 'portfolioChange') {
      return;
    }
    this.router.navigate(['/goals', this.goal?.id], {
      fragment: 'portfolio',
    });
    this.scrollToTop();
  }

  scrollToTop() {
    document.body.scrollTop = 0;
    try {
      window.scrollTo({ top: 0 });
    } catch (error) {
      console.log('scrollToTop', [error]);
    }
  }

  goActivities() {
    if (this.goal?.state == 'portfolioChange') {
      return;
    }
    if (this.goal?.haveDeposited && this.goal?.haveTransactionsProcessed) {
      this.router.navigate(['/goals', this.goal?.id], {
        fragment: 'activities',
      });
      this.scrollToTop();
    }
  }

  goPerformance() {
    if (this.goal?.state == 'portfolioChange') {
      return;
    }
    if (this.goal?.haveDeposited && this.goal?.haveTransactionsProcessed) {
      this.router.navigate(['/goals', this.goal?.id], {
        fragment: 'performance',
      });
      this.scrollToTop();
    }
  }

  iCanGoToPerformance() {
    if (this.goal?.state == 'portfolioChange') {
      return false;
    }
    if (this.goal?.haveDeposited && this.goal?.haveTransactionsProcessed) {
      return true;
    } else {
      return false;
    }
  }
}
